import { getCookie } from "cookies-next"
import { CookieNameEnum } from "../constants/cookie-names"

export default class PathHelper {
    public static getHostname(hostname: string): string {
        const parts = hostname.split('.')
        let host = parts[1]

        if (parts[2])
            host += '.' + parts[2]

        if (parts[3])
            host += '.' + parts[3]

        if (parts[4])
            host += '.' + parts[4]

        return host
    }

    public static getDomain = () => {
        const domain = getCookie(CookieNameEnum.Domain)
        return domain as string
    }

    public static clearQueryParams() {
        const currentParams = new URLSearchParams(window.location.search)
        const localMode = currentParams.get('localmode')

        const url = new URL(window.location.href)
        url.search = ""

        if (localMode)
            url.searchParams.set('localmode', localMode)

        window.history.replaceState(null, "", url.toString())
    }

    public static AddQueryParam(name: string, value: string) {
        const params = new URLSearchParams(window.location.search)
        params.set(name, value)
        window.history.pushState(null, "", `?${params.toString()}`)
    }
}